import Cierre from "./Cierre";

export default Cierre;
